// @module Ames.OperationGuidesPage.OperationGuidesPage
define("Ames.OperationGuidesPage.OperationGuidesPage.View", [
  "ames_operationguidespage_operationguidespage.tpl",

  "Ames.OperationGuidesPage.OperationGuidesPage.SS2Model",

  "Backbone",
], function (
  ames_operationguidespage_operationguidespage_tpl,

  OperationGuidesPageSS2Model,

  Backbone
) {
  "use strict";

  // @class Ames.OperationGuidesPage.OperationGuidesPage.View @extends Backbone.View
  return Backbone.View.extend({
    template: ames_operationguidespage_operationguidespage_tpl,

    initialize: function (options) {
      this.model = new OperationGuidesPageSS2Model();
      this.items = [];
      var self = this;
      this.model.fetch().done(function (result) {
        self.items = result.data;
		// sort the items by title
		self.items.sort(function (a, b) {
		  return a.mpn.toLowerCase() > b.mpn.toLowerCase() ? 1 : -1;
		});
        self.render();
      });
    },

    events: {},

    bindings: {},

    childViews: {},

    //@method getContext @return Ames.OperationGuidesPage.OperationGuidesPage.View.Context
    getContext: function getContext() {
      //@class Ames.OperationGuidesPage.OperationGuidesPage.View.Context
      return {
		items: this.items,
	  };
    },
  });
});
